// Module
var code = `<section id="transfer-customer" class="box">
  <sub-header header="\$ctrl.subHeaderDescription"></sub-header>
  <customer-group-access></customer-group-access>

  <div class="tab-content">
    <table class="table">
      <tbody class="tbody">
      <tr>
        <td class="label">
          Target branch:
        </td>
        <td class="values">
          <select ng-model="\$ctrl.targetBranchId"
                  ng-options="branch.id as branch.name for branch in \$ctrl.selectableBranches"
                  ng-change="\$ctrl.onBranchChange()"
                  required>
          </select>
        </td>
      </tr>
      <tr>
        <td class="label">
          Target group:
        </td>
        <td class="values">
          <select ng-model="\$ctrl.targetCustomerGroupId"
                  ng-options="group.groupCustomerId as group.name for group in \$ctrl.selectableGroups"
                  required>
          </select>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="flex-end buttons">
      <button type="button"
              class="btn btn-warning"
              ng-click="\$ctrl.redirectBack()">
        Cancel
      </button>

      <button type="submit"
              class="btn btn-primary"
              ng-click="\$ctrl.transfer()"
              ng-disabled="\$ctrl.hasNoCustomerToTransfer()">
        Transfer
      </button>
    </div>


    <div class="alert" ng-if="\$ctrl.successTransfers.length > 0">
      <div class="spacer-small"></div>
      <div class="content-row">
        <span>Successful customer transfer(s):&nbsp;</span>
      </div>
      <div class="spacer-medium"></div>
      <table class="table-content">
        <tr ng-repeat="item in \$ctrl.successTransfers">
          <td>
            {{ item }}
          </td>
        </tr>
      </table>
    </div>

    <div class="alert alert--danger" ng-if="\$ctrl.failedTransfers.length > 0">
      <div class="spacer-small"></div>
      <div class="content-row">
        <span>Failed customer transfer(s):&nbsp;</span>
      </div>
      <div class="spacer-medium"></div>
      <table class="table-content">
        <tr ng-repeat="item in \$ctrl.failedTransfers">
          <td>
            {{ item.name }} ({{ item.error }})
          </td>
        </tr>
      </table>
    </div>

  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/group-loans/transfer-customers-to-another-group/transfer-customers-to-another-group.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;